import { TETROMINOES } from '../game/tetrominoes';
import type { TetrominoType } from '../game/types';

interface PiecePreviewProps {
  type: TetrominoType | null;
  label: string;
  compact?: boolean;
}

export function PiecePreview({ type, label, compact = false }: PiecePreviewProps) {
  const occupied = new Set(type ? TETROMINOES[type][0].map(({ x, y }) => `${x}:${y}`) : []);

  return (
    <div className={`piece-preview${compact ? ' piece-preview--compact' : ''}`} aria-label={`${label}: ${type ?? 'empty'}`}>
      <div className="mini-grid" aria-hidden="true">
        {Array.from({ length: 12 }, (_, index) => {
          const x = index % 4;
          const y = Math.floor(index / 4);
          const filled = occupied.has(`${x}:${y}`);
          return <span key={index} className={`mini-cell${filled && type ? ` piece-${type.toLowerCase()}` : ''}`} />;
        })}
      </div>
    </div>
  );
}
